export const USER_SETTINGS_API_PATH = 'user-settings';
export const PREFERENCE_OPT_OUT = 'optOut';
export const USER_PREFERENCES = 'user-preference';
export const FEATURE_IDENTITY_SCANNING = 'identity-scanning';
export const FEATURE_SIDEBAR_PINNING = 'sidebar-pinned';
export const FEATURE_THEME = 'sync-theme';
export const FEATURE_USER_ENABLED_FEATURES = 'user-enabled-features';
export const FEATURE_USER_SELECTABLE_OPTIONS = 'user-selectable-options';
export const FEATURE_SEARCH_HISTORY = 'search-history';
export const FEATURE_EOL_SAVED_URL = 'eol-saved-url';
export const FEATURE_ACADEMY_PROGRESS_MAP = 'academy-progress-map';
export const FEATURE_VIEW_MODE = 'view-mode';
export const FEATURE_DOCS_RECENTLY_VIEWED = 'docs-recently-viewed';
